export const API_URLS = {
  // New platform API (MDF_BACKEND_DEV): sign-in session, /v1/me, admin.
  // Local: http://localhost:3000, later https://api-new.mdf.lu
  PLATFORM: import.meta.env.VITE_API_BASE_URL,

  // AWS API Gateway — report generation
  // Reads VITE_REPORT_API for local dev (set in .env), falls back to production URL
  REPORT: import.meta.env.VITE_REPORT_API,

  // SUMO Closure API — closure checks, fast preview, full-closure jobs
  // Reads VITE_CLOSURE_API. Live: https://api-new.mdf.lu/closure (API Gateway,
  // access token). Local closure API: http://127.0.0.1:8080 together with
  // VITE_CLOSURE_API_AUTH=user-header.
  CLOSURE: import.meta.env.VITE_CLOSURE_API,
};

/**
 * Data files of the app (Digital Twin, reference data) on data.mdf.lu
 * (CloudFront in front of the private data bucket). Kept out of API_URLS on
 * purpose: Sentry adds trace headers to API_URLS, which would make every data
 * file request need a CORS preflight.
 *
 * The files need signed cookies (shared/lib/data-client.ts). Local frontend
 * against the live data: VITE_DATA_BASE_URL=http://localhost:5173/live-data
 * (Vite proxy); the configured https://data.mdf.lu file URLs then go through it.
 */
export const DATA_PUBLIC_URL = "https://data.mdf.lu";
export const DATA_BASE_URL: string =
  import.meta.env.VITE_DATA_BASE_URL || DATA_PUBLIC_URL;
